<template>
  <div>
    <BaseHeader class="pb-6" type="default">
      <b-row align-v="center" class="py-4">
        <b-col lg="12" cols="7">
          <h1 class="h2 text-white d-inline-block mb-0">Ajouter un produit</h1>
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <RouteBreadcrumb />
          </nav>
        </b-col>
      </b-row>
    </BaseHeader>

    <ProductForm @on-success="submit" @action="action = $event" />
  </div>
</template>

<script>
import { RouteBreadcrumb, BaseHeader } from '@coop-zone/coop-zone-argon'
import { mapGetters } from 'vuex'
import ProductForm from '@/components/Product/ProductForm'

export default {
  name: 'CatalogAdd',
  components: {
    RouteBreadcrumb,
    ProductForm,
    BaseHeader,
  },
  data() {
    return {
      action: null,
    }
  },
  computed: {
    ...mapGetters('products', {
      product: 'getProduct',
    }),
  },
  created() {
    this.$store.commit('products/SET_CURRENT_PRODUCT', null)
  },
  methods: {
    submit() {
      this.$notify({
        message: 'Le produit a bien été enregistré',
        timeout: 5000,
        icon: 'ni ni-check-bold',
        type: 'success',
      })

      if (this.action === 'save') {
        this.$router.push('/catalog/search')
      } else {
        this.$router.push(
          `/catalog/edit/${this.product.id}-${this.product.slug}`
        )
      }
    },
  },
}
</script>
